import gql from 'graphql-tag'

export interface IIpLocation {
  latitude: number
  longitude: number
  cityName: string | null
  regionName: string | null
}

export const IpLocationFieldsFragment = gql`
  fragment IpLocationFields on IpLocation {
    latitude
    longitude
    cityName
    regionName
  }
`
